import { State } from './models';

/**
 * Config strip state feature key
 */
export const CONFIGSTRIP_FEATURE_KEY = 'configStrip';

/**
 * Config strip feature partial state
 */
export interface PartialConfigStripState {
  /** CS feature state */
  readonly [CONFIGSTRIP_FEATURE_KEY]: State;
}
